module.exports = __webpack_public_path__ + "h5/img/2.2fd9be43.png";